import { DELETE_ARTIST, GET_ARTISTS_LIST, SET_ARTIST_FILTER_TYPE } from '@jumbo/constants/ActionTypes';

const INIT_STATE = {
  artistsList: [],
  artist: {},
  artistFilters: {
    page: 1,
    by_name: '',
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_ARTIST_FILTER_TYPE: {
      return {
        ...state,
        artistFilters: action.payload,
      };
    }
    case GET_ARTISTS_LIST: {
      return {
        ...state,
        artistsList: action.payload,
      };
    }
    case DELETE_ARTIST: {
      return {
        ...state,
        artistsList: state.artistsList.filter(item => item.id !== action.payload),
      };
    }
    default:
      return state;
  }
};
